import { Typography } from "@mui/material";

const MdaFilterPlaceholder = () => (
  <Typography
    sx={{
      color: "#687890",
      display: "flex",
      alignItems: "center",
      fontSize: "0.875rem",
      minHeight: 40,
      mt: { xs: 0, sm: "23px" },
    }}
  >
    Select a client to see filters.
  </Typography>
);

export default MdaFilterPlaceholder;
